import { color, radius,spacing } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled.div`
  border: 1px solid ${color('gray.04')};
  border-radius: ${radius('xl')};
  padding: ${spacing(6, 6, 2)};
`

export const Content = styled.div``

export const SubmitWrapper = styled.div`
  margin-top: ${spacing(6)};
  padding-bottom: ${spacing(4)};
  position: sticky;
  bottom: 0;
  background: ${color('white')};
`
